import commonStrings from "rivals/shared/strings/common";
import registrationStrings from "rivals/shared/strings/registration";

export default {
  ...commonStrings,
  ...registrationStrings,
  birthday: "Date of Birth",
  birthdayInputPlaceholder: "mm/dd/yyyy",
  captchaFailure:
    "Captcha detected suspicious activity. Please try registering again, or contact customer care if the error persists.",
  createAccountButton: "Create Account",
  emailError: "Your email must be a valid email",
  passwordError: "Invalid password",
  prohibitGdprReg: "Account registration is unavailable in your location"
};
